import { SET_LOGGED_IN, SET_LOGGED_OUT, START_AUTHENTICATION } from './constants';

// action to toggle to logged in state
export const setLoggedIn = () => ({
	type: SET_LOGGED_IN,
});

// action to toggle to logged out state
export const setLoggedOut = () => ({
	type: SET_LOGGED_OUT,
});

export const startAuthentication = () => ({
	type: START_AUTHENTICATION,
});
